<template>
  <div>
    <SignupSuccess
      v-if="page == 'success'"
      :nameTh="form.step1.nameTh"
      :lastNameTh="form.step1.lastNameTh"
    />
    <div v-else class="pd-y-3 pd-x-2 custom-template">
      <div v-loading="loading" class="box-tat-action pd-x-2 pd-y-1 box-step">
        <Header title="ลงทะเบียนเรียนออนไลน์" />
        <el-row type="flex" class="height-100 custom-flex nochang-to-bottom">
          <el-col :span="24" :md="7" :lg="6">
            <div class="height-circle">
              <el-steps
                :direction="widthMax < 991 ? '' : 'vertical'"
                :active="page"
              >
                <el-step
                  v-for="item in stepList"
                  :key="item.id"
                  class="box-circle-step"
                  :class="{
                    success: page > item.id,
                    active: page == item.id || page > item.id,
                    setflexbasis: widthMax < 991,
                  }"
                >
                  <template v-if="page > item.id" slot="icon">
                    <i class="fas fa-check"></i>
                  </template>
                  <template slot="title" v-if="widthMax > 991">
                    <h5 class="text-font-18 text-left mg-y-less">
                      ขั้นตอนที่ {{ item.id }} {{ item.label }}
                    </h5>
                  </template>
                </el-step>
              </el-steps>
              <div v-if="widthMax < 991">
                <div v-for="item in stepList" :key="item.id">
                  <p class="font-show-step" v-if="page == item.id">
                    ขั้นตอนที่ {{ item.id }} {{ item.label }}
                  </p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col
            :span="24"
            :md="17"
            :lg="18"
            class="border-l border-color-primary border-semi-bold"
          >
            <div class="pd-x-4">
              <SignupStep1
                v-if="page == 1"
                @setFormStep="setFormStep"
                :value="typeof form.step1 != 'undefined' ? form.step1 : null"
              />
              <SignupStep2
                v-if="page == 2"
                @setFormStep="setFormStep"
                :value="typeof form.step2 != 'undefined' ? form.step2 : null"
              />
              <SignupStep3
                v-if="page == 3"
                :form="form"
                @signup="signup"
                @setPage="setPage"
              />
            </div>
          </el-col>
        </el-row>
      </div>
      <div id="footer">
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/template/Header";
import Footer from "@/components/template/Footer";
import SignupStep1 from "@/components/signup/SignupStep1";
import SignupStep2 from "@/components/signup/SignupStep2";
import SignupStep3 from "@/components/signup/SignupStep3";
import SignupSuccess from "@/components/signup/SignupSuccess";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    Header,
    Footer,
    SignupStep1,
    SignupStep2,
    SignupStep3,
    SignupSuccess,
  },
  computed: {
    register() {
      return this.$store.state.register;
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      page: 1,
      stepList: [
        { id: 1, label: "ข้อมูลส่วนบุคคล", success: false },
        { id: 2, label: "ข้อมูลหน่วยงาน", success: false },
        { id: 3, label: "ยืนยันข้อมูล", success: false },
      ],
      form: {},
      loading: false,
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.widthMax= window.innerWidth
    },
    async setFormStep(data, page) {
      this.form[`step${page}`] = data;
      this.page += 1;
    },

    setPage(page) {
      this.page = page;
    },
    signup() {
      this.loading = true;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();

      if (this.form.step1.image) {
        formData.append("file", this.form.step1.image.raw);
      }

      formData.append("profileFrom", "");
      formData.append("titleName", this.form.step1.prefix);
      formData.append("nameTH", this.form.step1.nameTh);
      formData.append("surnameTH", this.form.step1.lastNameTh);
      formData.append("nameEN", this.form.step1.nameEn);
      formData.append("surnameEN", this.form.step1.lastNameEn);
      formData.append(
        "countryCode",
        this.form.step1.phoneNumberObj.countryCode
      );
      formData.append("mobilephone", this.form.step1.phoneNumber);
      formData.append("identification", this.form.step1.idCard);
      formData.append("birthday", this.form.step1.birthDay);
      formData.append("position", this.form.step1.position);
      formData.append("address", this.form.step1.address);
      formData.append("postcode", this.form.step1.postcode);
      formData.append("subdistrict", this.form.step1.subDistrict);
      formData.append("district", this.form.step1.district);
      formData.append("province", this.form.step1.province);

      let institution = {
        name: this.form.step2.agency,
        type: this.form.step2.agencyType,
        etc: this.form.step2.etc,
        address: this.form.step2.address,
        postcode: this.form.step2.postcode,
        subdistrict: this.form.step2.subDistrict,
        district: this.form.step2.district,
        province: this.form.step2.province,
      };
      formData.append("institution", JSON.stringify(institution));
      formData.append("email", this.register.email);
      formData.append("password", this.register.password);
      formData.append("from", "system");

      HTTP.post(`sign/up`, formData, config)
        .then((res) => {
          if (res.data.success) {
            this.page = "success";
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("signup error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>

